import Search, { ISearch } from '@/models/search'

import config from '@/config'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)

export default class SearchService extends BaseService<Search> {
  protected subdomain = ''
  readonly groupId: string

  model(): typeof Search {
    return Search
  }

  constructor(locationId: string, groupId: string) {
    super(locationId)
    this.groupId = groupId
    this.basePath = `/${this.locationId}/groups/${this.groupId}`
  }

  async getSearchDiscussionResults(
    query: string,
    queryParams: Record<string, any>
  ): Promise<ISearch[]> {
    const response = await http.get(`${this.endpoint}/search`, {
      params: { query, ...queryParams },
    })
    return response.data
  }

  async getSearchDiscussionResultsByChannel(
    query: string,
    queryParams: Record<string, any>,
    channelId: string
  ): Promise<ISearch[]> {
    const response = await http.get(
      `${this.endpoint}/channels/${channelId}/search`,
      {
        params: { query, ...queryParams },
      }
    )
    return response.data
  }
}
